import { apiRequest } from './client'
import type {
  SilkContest,
  SilkContestEntry,
  SilkContestEntryList,
  SilkContestList,
  SilkContestReward,
  SilkContestRewardGrant,
  SilkContestSeason,
  SilkContestSeasonList,
  SilkCreateRewardBody,
  SilkCreateSeasonBody,
  SilkSettleResult,
  SilkSubmitEntryBody,
} from './types'

export const contestsApi = {
  list: (params?: {
    status?: string
    category_code?: string
    limit?: number
    offset?: number
  }) => apiRequest<SilkContestList>('/api/v1/contests', { query: params, auth: false }),

  get: (id: number) => apiRequest<SilkContest>(`/api/v1/contests/${id}`, { auth: false }),

  listEntries: (id: number, params?: { limit?: number; offset?: number; all?: boolean }) =>
    apiRequest<SilkContestEntryList>(`/api/v1/contests/${id}/entries`, {
      auth: false,
      query: {
        limit: params?.limit,
        offset: params?.offset,
        all: params?.all ? 1 : undefined,
      },
    }),

  submit: (id: number, body: SilkSubmitEntryBody) =>
    apiRequest<SilkContestEntry>(`/api/v1/contests/${id}/entries`, { method: 'POST', body }),

  /** 当前用户在本赛事的投稿(任意审核状态);无投稿时 40441 */
  getMyEntry: (contestId: number) =>
    apiRequest<SilkContestEntry>(`/api/v1/contests/${contestId}/entries/mine`),

  /** 退赛(仅赛事 open 阶段;退还报名费) */
  withdrawEntry: (entryId: number) =>
    apiRequest<{ ok: boolean }>(`/api/v1/entries/${entryId}`, { method: 'DELETE' }),

  vote: (id: number, entryId: number) =>
    apiRequest<{ ok: boolean }>(`/api/v1/contests/${id}/votes`, {
      method: 'POST',
      body: { entry_id: entryId },
    }),

  /** judge 打分 */
  score: (id: number, body: { entry_id: number; score: number; comment?: string }) =>
    apiRequest<{ id: number }>(`/api/v1/contests/${id}/scores`, { method: 'POST', body }),

  /* ---- 赛季 ---- */
  listSeasons: (id: number, params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkContestSeasonList>(`/api/v1/contests/${id}/seasons`, {
      auth: false,
      query: params,
    }),
  getSeason: (id: number) =>
    apiRequest<SilkContestSeason>(`/api/v1/seasons/${id}`, { auth: false }),
  createSeason: (contestId: number, body: SilkCreateSeasonBody) =>
    apiRequest<SilkContestSeason>(`/api/v1/contests/${contestId}/seasons`, {
      method: 'POST',
      body,
    }),
  advanceSeason: (seasonId: number, status: 'judging' | 'open' | 'archived') =>
    apiRequest<SilkContestSeason>(`/api/v1/seasons/${seasonId}/status`, {
      method: 'PATCH',
      body: { status },
    }),
  settleSeason: (seasonId: number) =>
    apiRequest<SilkSettleResult>(`/api/v1/seasons/${seasonId}/settle`, { method: 'POST' }),
  listGrants: (seasonId: number) =>
    apiRequest<{ items: SilkContestRewardGrant[]; total: number }>(
      `/api/v1/seasons/${seasonId}/grants`,
      { auth: false },
    ),

  /* ---- 奖励档位 ---- */
  listRewards: (contestId: number) =>
    apiRequest<{ items: SilkContestReward[]; total: number }>(
      `/api/v1/contests/${contestId}/rewards`,
      { auth: false },
    ),
  createReward: (contestId: number, body: SilkCreateRewardBody) =>
    apiRequest<SilkContestReward>(`/api/v1/contests/${contestId}/rewards`, {
      method: 'POST',
      body,
    }),
  deleteReward: (rewardId: number) =>
    apiRequest<{ ok: boolean }>(`/api/v1/rewards/${rewardId}`, { method: 'DELETE' }),
}
